import classNames from 'classnames';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../Button';
import DotsLoader from '../../DotsLoader';
import Input from '../../InputNew';
import NavigationBar from '../../NavigationBar/NavigationBar';
import { getNextButtonStyles } from '../../../utils/tbbRegistration';

const SignupForm = ({
  password,
  confirmPassword,
  errorMessage,
  loading,
  isExternalEmbedded,
  storeConfig,
  onPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
  onGoBack,
}) => (
  <div className="GlobalLoginV2__content--form">
    <NavigationBar
      onGoBack={onGoBack}
      className={classNames('GlobalLoginV2__navigation', { isExternalEmbedded })}
    />
    <h2 className="GlobalLoginV2__content--title">
      Set your password
    </h2>
    <p className="GlobalLoginV2__content--subtitle">
      Create a password to log in later on
    </p>
    <Input
      type="password"
      id="signupPassword"
      label="Password"
      placeholder="Password"
      value={password}
      onChange={onPasswordChange}
      errorMessage={errorMessage && (errorMessage.includes('password') || errorMessage.includes('characters')) ? errorMessage : ''}
      disabled={loading}
    />
    <Input
      type="password"
      id="confirmPassword"
      label="Confirm Password"
      placeholder="Confirm Password"
      value={confirmPassword}
      onChange={onConfirmPasswordChange}
      errorMessage={
        (() => {
          if (errorMessage && errorMessage.includes('match')) {
            return errorMessage;
          }
          if (confirmPassword && password !== confirmPassword) {
            return 'Passwords do not match';
          }
          return '';
        })()
      }
      disabled={loading}
    />
    <Button
      type={isExternalEmbedded ? BUTTON_TYPE.PRIMARY : BUTTON_TYPE.QUATERNARY}
      size={BUTTON_SIZE.LARGE}
      onClick={onSubmit}
      style={getNextButtonStyles(storeConfig)}
      disabled={
        loading ||
        !password ||
        !confirmPassword ||
        password !== confirmPassword
      }
    >
      {loading ? <DotsLoader /> : 'Continue'}
    </Button>
  </div>
);

export default SignupForm;
